<template>
  <div>
    <div v-if="authorised">
      <add-user-modal v-if="activeUser.is_admin" v-perms="[`multi_user`]" :customer="customer" />
      <add-uploader-modal v-if="activeUser.is_admin" v-perms="['third_party_uploader']" :customer="customer" />

      <!--begin::Portlet-->
      <div class="kt-portlet kt-portlet--bordered" data-ktportlet="true">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="la la-users" />
            </span>
            <h3 class="kt-portlet__head-title">
              Users
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-group">
              <add-user-button v-if="activeUser.is_admin" />
              <a href="#" data-ktportlet-tool="toggle" class="btn btn-sm btn-icon btn-clean btn-icon-md"><i class="la la-angle-down" /></a>
            </div>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-portlet__content">
            <div v-if="!permissionsCanAccessFeature('multi_user')" class="alert alert-grey">
              Your current plan does not support multiple users. If you want multiple users, please contact SharpStream to upgrade you account
            </div>

            <user-grid v-if="users.length" :active-user="activeUser" :users="users" />
          </div>
        </div>
      </div>
      <!--end::Portlet-->

      <!--begin::Portlet-->
      <div v-perms="['third_party_uploader']" class="kt-portlet kt-portlet--bordered" data-ktportlet="true">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="la la-users" />
            </span>
            <h3 class="kt-portlet__head-title">
              Uploaders
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-group">
              <add-uploader-button v-if="activeUser.is_admin" />
              <a href="#" data-ktportlet-tool="toggle" class="btn btn-sm btn-icon btn-clean btn-icon-md"><i class="la la-angle-down" /></a>
            </div>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-portlet__content">
            <user-grid v-if="uploaderUsers.length" :container-class="'dark'"
                       :active-user="activeUser" :users="uploaderUsers" />
          </div>
        </div>
      </div>
      <!--end::Portlet-->
    </div>
    <div v-else>
      <unauthorised :message="unauthorisedMessage" />
    </div>
    <delete-confirm-modal name="delete-user" entity-type="User" />
  </div>
</template>

<script>
import AddUserButton from "VuePartials/AddUserButton";
import AddUserModal from "VueModals/AddUserModal";
import AddUploaderModal from "VueModals/AddUploaderModal";
import AddUploaderButton from "VuePartials/AddUploaderButton";
import UserGrid from "VuePartials/App/UserGrid";
import UsersMixin from "VueMixins/UsersMixin";
import UserRolesMixin from "VueMixins/UserRolesMixin";
import DeleteConfirmModal from 'VueModals/DeleteConfirmModal';

export default {
  components: {
    UserGrid,
    AddUserModal,
    AddUserButton,
    AddUploaderModal,
    AddUploaderButton,
    DeleteConfirmModal,
  },
  mixins: [UsersMixin, UserRolesMixin],
  mounted() {
    this.getNormalUsers();
    this.getUploaderUsers();
  },
};
</script>

<style lang='scss'>
@use "~AssetsSass/_users.scss" as *;

.actions {
    button {
        width: 100%;
        border-left: none !important;
        border-right: none !important;
        border-bottom: none !important;
    }
    .dropdown-menu {
        width: 100%;
    }
}

.swal2-styled.swal2-cancel {
    border: 1px solid #ebedf2 !important;
    color: #212529 !important;
}

.add-user-buttons {
    margin-bottom: 20px;
    .btn {
        margin-right: 10px;
    }
}
</style>
